import PromiseCache from './MWPromiseCache';

/*
  Mobile Web Cornerstone Bridge duplicated from DomoWeb
 */

const loadFlutterApp = () => {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve, reject) => {
    const scriptImport = (src, script = document.createElement('script')) => {
      return new Promise((innerResolve, innerReject) => {
        script.src = src;
        script.async = true;
        script.onload = () => innerResolve();
        script.onerror = innerReject;
        document.body.appendChild(script);
      });
    };

    const basePath = '/public/@domo/cornerstone_bridge/build/web';

    // Load flutter_bootstrap.js script
    await scriptImport(`${basePath}/flutter_bootstrap.js`);

    const config = {
      entrypointBaseUrl: `${basePath}/`,
      canvasKitBaseUrl: `${basePath}/canvaskit/`,
      assetBase: `${basePath}/`,
    };

    window['_flutter'].loader.load({
      config,
      async onEntrypointLoaded (engineInitializer) {
        try {
          const engine = await engineInitializer.initializeEngine({
            multiViewEnabled: true,
            renderer: 'canvaskit',
            ...config, // for some reason it doesn't work unless config is placed here also.
          });
          const app = engine.runApp();
          resolve(app);
        } catch (e) {
          reject(e);
        }
      },
    });
  });
};

export class CornerstoneBridge {
  // The promise cache ensures that the flutter app is only loaded once
  static flutterAppPromiseCache = new PromiseCache({
    clearOnRouteChange: false,
  });

  /**
   * _Add a view to the flutter app_
   * @param hostElement - The element to host the view
   * @param initialData - The initial data to pass to the view
   * @returns The view id
   */
  static async addView(hostElement, initialData) {
    if (!this.flutterAppPromiseCache.has('flutterApp')) {
      this.flutterAppPromiseCache.store('flutterApp', loadFlutterApp());
    }
    const flutterApp = await this.flutterAppPromiseCache.retrieve('flutterApp');
    return flutterApp.addView({
      hostElement,
      initialData,
      viewConstraints: {
        minWidth: 0,
        minHeight: 0,
      },
    });
  }

  /**
   * _Remove a view from the flutter app_
   * @param viewId - The view id to remove
   */
  static async removeView(viewId) {
    const flutterApp = await this.flutterAppPromiseCache.retrieve('flutterApp');
    if (flutterApp) {
      flutterApp.removeView(viewId);
    }
  }
}
